var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    CreateSqlStatementBrickModel: function (opts) {
        var form = opts.form
            , entityDropdown = form.find('[name="EntityId"]');

        entityDropdown.on('change', loadAttributeEditors);
        Operator.Layout.setupCollections(form, loadAttributeEditors);
        loadAttributeEditors();
        
        function loadAttributeEditors() {
            var entityId = entityDropdown.val();
            var attributeDropdown = $('.attribute-dropdown[data-entity-id="' + entityId + '"]').clone();
            
            _.forEach(form.find('.statement-model [name$="AttributeId"]'), function (e) {
                var $e = $(e);
                $e.html(attributeDropdown.html());
                $e.val($e.data('current'));
            });
        }
    },
    HashValuesBlockModel: function(opts) {
        var form = opts.form;
        Operator.Layout.setupCollections(form);
    }
});